import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=47ec84ae&"
import script from "./Confirm.vue?vue&type=script&lang=js&"
export * from "./Confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47ec84ae')) {
      api.createRecord('47ec84ae', component.options)
    } else {
      api.reload('47ec84ae', component.options)
    }
    module.hot.accept("./Confirm.vue?vue&type=template&id=47ec84ae&", function () {
      api.rerender('47ec84ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/Confirm.vue"
export default component.exports